import React, { useState } from "react";
import { createCheckoutSession } from "../../services/stripe.tsx";
import { logTrialCheckoutStarted } from "../../analytics/onboarding.ts";

interface SubscriptionButtonProps {
  priceId: string;
  userId: string;
  isLoading?: boolean; // optional now if you want
  planName: string;
  isEducational: boolean;
  trialLength: number;
  alreadyTrialed?: boolean;
  /** Stripe Promotion Code ID (promo_...); passed to Firebase extension as top-level `promotion_code`. */
  promotionCodeId?: string | null;
  successUrl?: string;
  cancelUrl?: string;
  onBeforeCheckout?: () => Promise<{
    successUrl?: string;
    cancelUrl?: string;
  } | void>;
}

export default function SubscriptionButton({
  priceId,
  userId,
  planName,
  trialLength,
  alreadyTrialed,
  promotionCodeId,
  successUrl,
  cancelUrl,
  onBeforeCheckout,
}: SubscriptionButtonProps) {
  const [loading, setLoading] = useState(false);

  const previousTrialed = alreadyTrialed ? true : false;
  const handleSubscribe = async () => {
    setLoading(true);
    console.log("promotionCodeId", promotionCodeId);
    try {
      const redirects = (await onBeforeCheckout?.()) || {};
      logTrialCheckoutStarted({
        price_id: priceId,
        plan_name: planName,
        surface: "subscription_button",
      });
      await createCheckoutSession(priceId, userId, trialLength, previousTrialed, {
        promotionCodeId,
        successUrl: redirects.successUrl || successUrl,
        cancelUrl: redirects.cancelUrl || cancelUrl,
      });
    } catch (error) {
      console.error("Subscription error:", error);
      alert("Failed to start subscription process. Please try again.");
      setLoading(false);
    }
    console.log("Done sub");
    // optionally you can reset loading to false here if needed
  };

  return (
    <button
      onClick={handleSubscribe}
      disabled={loading}
      className={`mt-8 block w-full ${planName === "Pro" || planName === "Professional"
        ? "bg-blue-600 hover:bg-blue-700"
        : "bg-slate-900"
        } transition-all ease-linear rounded-md py-2 text-sm font-semibold text-white text-center`}
    >
      {loading ? (
        <span className="flex items-center justify-center">
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Processing...
        </span>
      ) : (
        `  🎉 ${alreadyTrialed ? "Upgrade to DrillFlo Pro." : `Start ${trialLength}-Day Free Trial `}`
      )}
    </button>
  );
}
